/**
 * 表格默认配置
 */
const noop = function () {};

export default {
  pk: 'id',
  // 数据主键字段
  contextPath: '',
  // 根路径
  url: '',
  // 请求表格数据的后台接口, url和pagePath二选一必填
  pagePath: '',
  // 请求表格数据页面地址, url和pagePath二选一必填
  schema: true,
  // 启用schema，必须定义 contextPath && 未定义contextPath时 schema 不生效
  action: '',
  // emap动作名
  datamodel: null,
  // 一般为emap返回的数据模型,
  beforeSend: noop,
  // 请求发送前的回调函数
  defaultParams: false,
  // 查询请求默认附加参数
  onceParams: false,
  // 查询请求默认附加参数
  width: '100%',
  // 宽度
  height: 'auto',
  // 高度
  pageable: true,
  // 是否支持分页
  customOptions: null,
  // 初始化表格的options，允许干预
  pagerMode: 'advanced',
  // 分页形式 'advanced' 'simple'
  serverProcessing: true,
  // 是否开启服务端分页
  pageSizeOptions: ['10', '20', '50', '100'],
  // 分页条数选项
  // localization: localization, // @deprecated
  sortable: false,
  // 是否支持排序
  columnsReorder: false,
  // 是否开启列拖拽排序
  selectionMode: 'custom',
  // Sets or gets the selection mode. Possible values: "multipleRows", "singleRow" and "custom". In the "custom" mode, rows could be selected/unselected only through the API.
  enableBrowserSelection: true,
  // Enables or disables the default text selection of the web browser.
  // incrementalSearch: false, // @deprecated
  columnsResize: true,
  // Sets or gets columnsResize.
  colHasMinWidth: true,
  // 列宽是否有默认最小值100px
  minLineNum: null,
  // 最小高度行数
  alwaysHide: ['WID', 'TBRQ', 'TBLX', 'CZRQ', 'CZZ', 'CZZXM'],
  // 自定义显示列的隐藏字段
  // fastRender: false, // @deprecated 快速渲染， 用于提高表格渲染速度
  canEdit: true,
  // 是否可编辑
  isCellEditable: null,
  // 是否自定义单元格渲染函数
  isEditMode: false,
  // 是否为编辑模式
  editPageable: false,
  // 编辑模式下的分页配置
  isOnceEmpty: false,
  // 表格默认是否为空，不加载数据
  mustSelect: true,
  // 自定义显示列弹窗是否开启必须勾选字段校验
  defaultCellsRenderer: undefined,
  // 这是一个同步函数，设置该函数将会忽略默认渲染，必须返回一个字符串。函数的入参：row, column, value, rowData, colModel, settings
  saveSchemaCallback: null,
  // 保存列方案之后的回调
  cellRender: null // 自定义单元格渲染函数

};